export default __webpack_public_path__ + "static/coronini_img1-68bd2577e0897b2b4169713015714b38.png";